import React from 'react';
import { EnrollmentContent } from './EnrollmentText.styled';
import CmsContent from '@components/CmsCard/CmsCard';

const EnrollmentText: React.FunctionComponent = () => {
    return (
        <EnrollmentContent>
            <CmsContent contentId={'8a2be628-cdb5-45c4-a2d1-a1e3dcbb3535'} />
        </EnrollmentContent>
    );
};

export default React.memo(EnrollmentText);
